import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { setToken } from '../services/storage';
import { sendTokenToExtension } from '../services/extensionHandoff';
import { useAuth } from '../hooks/auth';
import '../components/AuthCard/AuthCard.css';

function AuthCallback() {
  const navigate = useNavigate();
  const { refreshSession } = useAuth();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('working');
  const [message, setMessage] = useState('Finishing sign-in…');

  useEffect(() => {
    let cancelled = false;

    async function finishAuth() {
      const hash = window.location.hash.startsWith('#')
        ? window.location.hash.slice(1)
        : '';
      const hashParams = new URLSearchParams(hash);
      const token = hashParams.get('token');

      if (!token) {
        if (!cancelled) {
          setStatus('error');
          setMessage('Missing sign-in token. Please try again.');
        }
        return;
      }

      setToken(token);
      window.history.replaceState(null, '', window.location.pathname + window.location.search);

      const source = searchParams.get('source');
      const extensionId = searchParams.get('extensionId');
      const isExtensionFlow = source === 'extension' && Boolean(extensionId);

      if (isExtensionFlow) {
        try {
          await sendTokenToExtension(extensionId, token);
        } catch (err) {
          console.warn('Extension handoff failed', err);
        }
        if (!cancelled) {
          setStatus('done');
          setMessage(
            'You can return to the Numus extension. Your original tab should be active again.'
          );
        }
        return;
      }

      const me = await refreshSession();
      if (cancelled) return;

      if (!me) {
        setStatus('error');
        setMessage('Could not verify your session. Please try again.');
        return;
      }

      navigate('/profile', { replace: true });
    }

    finishAuth();
    return () => {
      cancelled = true;
    };
  }, [navigate, refreshSession, searchParams]);

  return (
    <div className="auth-page">
      <Link to="/" className="auth-logo">
        <img src="/logo.svg" alt="" className="auth-logo-icon" width="40" height="40" />
        <span className="al-logo">Numus</span>
      </Link>
      <div className="auth-card">
        <h1 className="auth-title">
          {status === 'error' ? 'Sign-in failed' : status === 'done' ? "You're signed in" : 'Signing in'}
        </h1>
        <p className="auth-extension-done">{message}</p>
        {status === 'error' ? (
          <p className="auth-footer">
            <Link to="/login" className="auth-footer-link">
              Back to log in
            </Link>
          </p>
        ) : null}
      </div>
    </div>
  );
}

export default AuthCallback;
